module.exports = __webpack_public_path__ + "img/4-2.c5dbe902.png";